/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_TitleInputs */

const en_admin_create_company_title = /** @type {(inputs: Admin_Create_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create company`)
};

const de_admin_create_company_title = /** @type {(inputs: Admin_Create_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen anlegen`)
};

/**
* | output |
* | --- |
* | "Create company" |
*
* @param {Admin_Create_Company_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_title = /** @type {((inputs?: Admin_Create_Company_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_title(inputs)
	return en_admin_create_company_title(inputs)
});